import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/app/globals-animations.css");
;
import(/* webpackMode: "eager", webpackExports: ["WordPressFool"] */ "/app/components/site/shell/WordPressFool.tsx");
;
import(/* webpackMode: "eager" */ "/app/styles/modern-hero.css");
;
import(/* webpackMode: "eager" */ "/app/styles/bright-theme.css");
;
import(/* webpackMode: "eager" */ "/app/styles/components.css");
